// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconWarehouse1 = createRemixIcon('IconWarehouse1', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.836 1.07L12 .319l-.836.753l-10 9l-.414.372V23.25h22.5V10.443l-.414-.372zM3.25 20.75v-9.193L12 3.682l8.75 7.875v9.193zm3-1.25v-5h5v5zm6.5 0v-5h5v5zM9.5 8.5v5h5v-5z\" clip-rule=\"evenodd\"/>");
